import { SvgIcon, SvgIconProps } from '@material-ui/core';

const TransportationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 12">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-16.000000, -67.000000)"
          fill="#3864E9"
          fillRule="nonzero"
        >
          <g id="Siderail" transform="translate(0.000000, 40.037037)">
            <g transform="translate(16.000000, 24.030093)">
              <g transform="translate(0.000000, 2.994907)">
                <path d="M14.8571429,0 L1.14285714,0 C0.511674572,0 0,0.512148344 0,1.14391534 L0,10.2952381 C0,10.9270051 0.511674572,11.4391534 1.14285714,11.4391534 L14.8571429,11.4391534 C15.4883254,11.4391534 16,10.9270051 16,10.2952381 L16,1.14391534 C16,0.512148344 15.4883254,0 14.8571429,0 Z M4.57142857,7.72142857 C4.57142857,8.19525382 4.18767264,8.57936508 3.71428571,8.57936508 C3.24089879,8.57936508 2.85714286,8.19525382 2.85714286,7.72142857 L2.85714286,3.71772487 C2.85714286,3.24389962 3.24089879,2.85978836 3.71428571,2.85978836 C4.18767264,2.85978836 4.57142857,3.24389962 4.57142857,3.71772487 L4.57142857,7.72142857 Z M8.85714286,7.72142857 C8.85714286,8.19525382 8.47338693,8.57936508 8,8.57936508 C7.52661307,8.57936508 7.14285714,8.19525382 7.14285714,7.72142857 L7.14285714,3.71772487 C7.14285714,3.24389962 7.52661307,2.85978836 8,2.85978836 C8.47338693,2.85978836 8.85714286,3.24389962 8.85714286,3.71772487 L8.85714286,7.72142857 Z M13.1428571,7.72142857 C13.1428571,8.19525382 12.7591012,8.57936508 12.2857143,8.57936508 C11.8123274,8.57936508 11.4285714,8.19525382 11.4285714,7.72142857 L11.4285714,3.71772487 C11.4285714,3.24389962 11.8123274,2.85978836 12.2857143,2.85978836 C12.7591012,2.85978836 13.1428571,3.24389962 13.1428571,3.71772487 L13.1428571,7.72142857 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default TransportationIcon;
